// extracted by mini-css-extract-plugin
export default {"aboutBg":"aboutBg__x0NNW","bg":"bg__r3ooG"};